export default "__VITE_ASSET__BhhydN6C__"